import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpModalComponent from './adpModal.component';

let adpModalModule = angular.module('adpModal', [
  uiRouter
])

.component('adpModal', adpModalComponent)

.name;

export default adpModalModule;



// WEBPACK FOOTER //
// ./src/app/components/adpModal/adpModal.js